import { tagMetadataKeys } from './tagMetadataKeys.js'

export interface ExportMetadataEntry {
	key: string
	value: string
}

export class ExportMetadataFactory {
	static create(
		uri: URL | { search: string; toString(): string }
	): ExportMetadataEntry[] {
		const dictionary = ExportMetadataFactory.getSearchParamsDictionary(
			uri.search
		)
		const result: ExportMetadataEntry[] = []
		for (const property in dictionary) {
			const parameter = {
				key: property,
				value: dictionary[property]
			}
			result.push(parameter)
		}

		const sourceUriMetadata = {
			key: tagMetadataKeys.SourceUriKey,
			value: uri.toString()
		}
		result.push(sourceUriMetadata)

		const startedMetadata = {
			key: tagMetadataKeys.ExportStartedKey,
			value: tagMetadataKeys.TrueValue
		}
		result.push(startedMetadata)

		return result
	}

	static getSearchParamsDictionary(search: string): Record<string, string> {
		const dictionary: Record<string, string> = {}
		const searchParams = new URLSearchParams(search)
		for (const key of searchParams.keys()) {
			const values = searchParams.getAll(key)
			if (values && values.length > 0) {
				dictionary[key] = values[0]
			} else {
				dictionary[key] = ''
			}
		}
		return dictionary
	}
}
